/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useMemo } from "react";
import { generateGuid } from "utils/empty-exists";

/**
 * Ensures every item in this given list has a guid
 * @template {object} T
 * @param {T[]} list
 * @returns {Array<T & ItemWithGuid>}
 */
export function useEnsureGuidList (list) {
    const ensuredList = useMemo(
        () => list.map((item) => {
            const guid = item.guid ?? generateGuid();
            return {
                guid,
                ...item,
            };
        }),
        [list]
    );
    
    // console.log('[useEnsureGuidList]', list, ensuredList)
    return ensuredList;
}

/**
 * @typedef {object} ItemWithGuid
 * @property {string} guid
 */
